module.exports = __webpack_public_path__ + "static/media/7.88b3980a.jpg";